import produce from "immer";
import { Product } from "typings/index";
import { ProductActions } from "./action";
import { ServerState } from "../ServerState";

export interface State extends ServerState<Product>
{
    pages: number;
}

const initialState: State = {
    
    byId: {},
    pages: 0
};

const reducer = (state = initialState, action: ProductActions): State => produce(state, draft =>
{
    if (action.type === "PRODUCTS_LOAD_SUCCESS")
    {
        const { products } = action;
        draft.byId = {};
        draft.pages = action.pages;
        for (const product of products)
        {
            draft.byId[product.id] = product;
        }
    }
    if (action.type === "GET_PRODUCTS_SUCCESS")
    {
        const { products } = action;
        for (const product of products)
        {
            draft.byId[product.id] = product;
        }
    }

    if (action.type === "PRODUCT_LOAD_SUCCESS")
    {
        const { product } = action;
        draft.byId[product.id] = product;

    }
    
    if (action.type ===  "CHANGE_PRODUCT_STATUS")
    {
        const { status, productId } = action;
        draft.byId[productId].status = status;
    } 
    if (action.type === "PRODUCT_UPDATE_MULTIPLE")
    {
        const { products } = action;
        for (const product of products)
        {
            draft.byId[product.id] = product;
        }
    }

});

export const getProducts = (state: State) => Object.keys(state.byId).map(id => state.byId[id]);

export const getPages = (state: State) => state.pages;

export const getProductById = (state: State, id: string) =>
{
    if (!state.byId[id])
    {
        return undefined;
    }
    const product = { ...state.byId[id] };
    const data = { ...product.data };
    
    if (product.parentId && product.parentId !== product.id)
    {
        let parent = getProductById(state, product.parentId);

        if (parent)
        {
            const keys: string[] = Object.keys(parent.data);
            const list = [ parent ];
            while (parent && parent.parentId)
            {
                parent = getProductById(state, parent.parentId);
                if (parent)
                {
                    list.push(parent);
                    keys.concat(Object.keys(parent.data));
                }
            }
        
            const uniq = new Set<string>(keys);
            uniq.forEach(key =>
            {
                const p = list.find((i) => i.data[key].value !== undefined);
                if (!p)
                {
                    return;
                }
                if (!data[key] || !data[key].value || (Array.isArray(data[key].value) && data[key].value.length === 0) || false)
                {
                    data[key] = {
                        ...p.data[key],
                        inherited: true
                    };
                }
                data[key].inheritedValue = p.data[key].value;
            });
        }
       
    }
    return {...product, data};
};

export default reducer;


// WEBPACK FOOTER //
// ./src/state/products/index.ts